import { render, staticRenderFns } from "./StudentBadgesSection.vue?vue&type=template&id=65f33e0d&scoped=true"
import script from "./StudentBadgesSection.vue?vue&type=script&lang=js"
export * from "./StudentBadgesSection.vue?vue&type=script&lang=js"
import style0 from "./StudentBadgesSection.vue?vue&type=style&index=0&id=65f33e0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f33e0d",
  null
  
)

export default component.exports